import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {RoutePrefix} from '../shared/route-prefix';
import {FilterParam} from '@ngx-ivengi/crud/request-params';

@Component({
  selector: 'app-owner-contact-form',
  templateUrl: './owner-contact-form.component.html'
})
export class OwnerContactFormComponent implements OnInit {

  public routePrefix: RoutePrefix;
  public contactFilter: FilterParam;

  constructor(
    private router: UIRouter
  ) {}

  public ngOnInit(): void {
    this.routePrefix = {
      entity: 'owner',
      entityId: this.router.stateService.params.id
    };

    this.contactFilter = {
      id: 0,
      key: 'roles',
      operator: 'eq',
      value: 'OWNER',
      filterFn: 'substringof',
      filterOutcome: 'true'
    };
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/owner/owner-contact-form.component.ts